import type { ReactNode } from 'react';

import { Button } from './button';

interface ToggleOption<T extends string> {
  value: T;
  label: string;
  content: ReactNode;
}

export function ToggleGroup<T extends string>({
  label,
  value,
  options,
  onValueChange,
  className = '',
}: {
  label: string;
  value: T;
  options: readonly ToggleOption<T>[];
  onValueChange: (value: T) => void;
  className?: string;
}): JSX.Element {
  return (
    <div className={`ui-toggle-group ${className}`.trim()} role="group" aria-label={label}>
      {options.map((option) => (
        <Button
          key={option.value}
          variant="bare"
          size="icon"
          className="ui-toggle-group__option"
          aria-label={option.label}
          aria-pressed={value === option.value}
          title={option.label}
          onClick={() => onValueChange(option.value)}
        >
          {option.content}
        </Button>
      ))}
    </div>
  );
}
